/* Layout repairs on top of the rendered page.

   Strike-through prices: the previous version rewrote EVERY line-through node
   on the page to the selected bundle's figure, every 600ms. So all three rows,
   the headline and the goggles tile showed the same compare-at (the 2-pack's
   $89.90 next to a one-mask price), and it fought the currency script, which
   is why EUR and USD flickered.

   Now:
   • the bundle rows and the goggles own their strike-through — never touched,
   • the headline shows the single-mask price, so it gets the single-mask
     compare-at and SAVE badge,
   • any node the currency script has already converted is left alone. */
(function(){
var B=window.IF_BUNDLES||[];
var MAP=window.IF_PRICE_MAP||{};
var GLOVES=window.IF_GLOVES_IMG||'';
var MYSTERY=window.IF_MYSTERY_IMG||'';
var FREESHIP=window.IF_FREESHIP_IMG||'';
var sizeMoved=false, lastUnlocked=-1;
var OWNED='#if-bundlerows,#if-bundles,#if-addons,#if-gift-row,#if-sticky,#if-reviews,#if-sg';

function headSave(){
var b=B[0];
if(!b||!b.was)return null;
var p=parseFloat(b.price), w=parseFloat(b.was);
if(!p||!w||w<=p)return null;
return 'SAVE '+Math.round((1-p/w)*100)+'%';
}

function patchBundles(){
var w=document.getElementById('if-bundles');
if(!w||!B.length)return;
var cards=w.querySelectorAll('button');
for(var i=0;i<cards.length&&i<B.length;i++){
var divs=cards[i].querySelectorAll('div');
if(divs.length<3)continue;
if(divs[1].textContent!==B[i].per)divs[1].textContent=B[i].per;
var want='$'+B[i].price;
if(divs[2].textContent!==want)divs[2].textContent=want;
}
}

function patchPrices(){
var root=document.getElementById('if');
if(!root)return;
var label=headSave();
var headWas=B[0]&&B[0].was?('$'+B[0].was):null;
var nodes=root.querySelectorAll('span,div,strong,b,p');
for(var k=0;k<nodes.length;k++){
var n=nodes[k];
if(n.children.length)continue;
if(n.getAttribute('data-if-cur'))continue;
var t=(n.textContent||'').trim();
var owned=n.closest&&n.closest(OWNED);

if(/^SAVE\s+\d+%$/.test(t)){
if(!owned&&label&&t!==label)n.textContent=label;
continue;
}
if(n.style&&(n.style.textDecoration||'').indexOf('line-through')>-1){
if(!owned&&headWas&&t!==headWas&&t.indexOf('$')===0)n.textContent=headWas;
continue;
}
var bare=t.replace('$','');
if(MAP[bare])n.textContent=(t.charAt(0)==='$'?'$':'')+MAP[bare];
}
var total=document.getElementById('if-total');
if(total&&!total.getAttribute('data-if-cur')){
var v=(total.textContent||'').trim().replace('$','');
if(MAP[v])total.textContent=MAP[v];
}
}

function promoteSizeGuide(){
if(sizeMoved)return;
var btn=document.getElementById('if-sg-open');
var rows=document.getElementById('if-bundlerows');
var bundles=document.getElementById('if-bundles');
var anchor=rows||bundles;
if(!btn||!anchor)return;
var oldRow=btn.parentNode;
sizeMoved=true;

btn.setAttribute('style','display:inline-flex; align-items:center; gap:7px; background:#FFF3EE; color:#C43100; border:1.5px solid #FFC7B2; border-radius:999px; padding:7px 13px; font-weight:800; font-size:12px; letter-spacing:.3px; cursor:pointer; font-family:Barlow,sans-serif;');
btn.innerHTML='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9h20v6H2z"></path><path d="M6 9v3M10 9v4M14 9v3M18 9v4"></path></svg><span>Fit &amp; sizing \u00b7 one size, 21\u201324\u2033</span>';

var holder=document.createElement('div');
holder.setAttribute('style','margin:0 0 11px;');
holder.appendChild(btn);
anchor.parentNode.insertBefore(holder,anchor);

if(oldRow&&oldRow.id!=='if')oldRow.style.display='none';
}

function patchGiftArt(){
var row=document.getElementById('if-gift-row');
if(!row)return;
var tiles=row.children;
if(tiles.length<3)return;
function setArt(tile,src,alt,fit){
var slot=tile.querySelector('span');
if(!slot)return;
var existing=slot.querySelector('img');
if(existing){if(existing.src.indexOf(src.split('?')[0])<0)existing.src=src;return;}
slot.innerHTML='<img src="'+src+'" alt="'+alt+'" style="width:100%; aspect-ratio:1/1; object-fit:'+(fit||'contain')+'; border-radius:7px; background:#fff; display:block;">';
}
if(FREESHIP)setArt(tiles[0],FREESHIP,'Free worldwide shipping','cover');
if(GLOVES)setArt(tiles[1],GLOVES,'Free Snow Gloves','contain');
if(MYSTERY)setArt(tiles[2],MYSTERY,'Free Mystery Mask','cover');
}

function animateUnlocks(){
var row=document.getElementById('if-gift-row');
if(!row)return;
var tiles=row.children, count=0;
for(var i=0;i<tiles.length;i++){
if(tiles[i].textContent.indexOf('MASKS')<0)count++;
}
if(lastUnlocked<0){lastUnlocked=count;return;}
if(count>lastUnlocked){
var t=tiles[count-1];
if(t){
t.classList.remove('if-just-unlocked');
void t.offsetWidth;
t.classList.add('if-just-unlocked');
setTimeout(function(){t.classList.remove('if-just-unlocked');},800);
}
}
lastUnlocked=count;
}

function run(){promoteSizeGuide();patchBundles();patchPrices();patchGiftArt();animateUnlocks();}

var n=0;
var iv=setInterval(function(){n++;run();if(n>50)clearInterval(iv);},150);
setInterval(function(){patchBundles();patchPrices();},600);
if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
setInterval(function(){
var g=document.getElementById('if-gift-row');
if(g&&!g.getAttribute('data-if-obs')){
g.setAttribute('data-if-obs','1');
new MutationObserver(function(){patchGiftArt();animateUnlocks();}).observe(g,{childList:true});
}
},600);
})();
